import Header from "components/readingplan/Header";

function ReadingPlan() {
  return (
    <>
      <Header />
    </>
  );
}

export default ReadingPlan;
